export const MODULE_NAME = 'lk-publications'


export const LK_PUBLICATIONS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  VIEW_ONCE: `${MODULE_NAME}.view-once`,
} as const
